export function apiErrorMessage(data: Record<string, unknown>, fallback: string): string {
  const err = data.error;
  return typeof err === 'string' && err.trim().length > 0 ? err : fallback;
}

export async function parseApiJson<T = Record<string, unknown>>(
  response: Response
): Promise<T> {
  const text = await response.text();
  if (!text.trim()) {
    return {} as T;
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    if (response.status === 429) {
      throw new Error('Too many requests. Please wait a minute, then click Refresh.');
    }
    const snippet = text.length > 120 ? `${text.slice(0, 120)}…` : text;
    throw new Error(snippet || `Server error (${response.status})`);
  }
}
